// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { ProcessRead } from "./ProcessRead";
import {
  ProcessReadFromJSON,
  ProcessReadFromJSONTyped,
  ProcessReadToJSON,
  ProcessReadToJSONTyped,
} from "./ProcessRead";

/**
 *
 * @export
 * @interface PageProcessRead
 */
export interface PageProcessRead {
  /**
   *
   */
  total: number;
  /**
   *
   */
  items: Array<ProcessRead>;
  /**
   *
   */
  limit?: number | null;
  /**
   *
   */
  offset?: number | null;
}

/**
 * Check if a given object implements the PageProcessRead interface.
 */
export function instanceOfPageProcessRead(value: object): value is PageProcessRead {
  if (!("total" in value) || value["total"] === undefined) return false;
  if (!("items" in value) || value["items"] === undefined) return false;
  return true;
}

export function PageProcessReadFromJSON(json: any): PageProcessRead {
  return PageProcessReadFromJSONTyped(json, false);
}

export function PageProcessReadFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PageProcessRead {
  if (json == null) {
    return json;
  }
  return {
    total: json["total"],
    items: (json["items"] as Array<any>).map(ProcessReadFromJSON),
    limit: json["limit"] === undefined ? undefined : json["limit"] === null ? null : json["limit"],
    offset:
      json["offset"] === undefined ? undefined : json["offset"] === null ? null : json["offset"],
  };
}

export function PageProcessReadToJSON(json: any): PageProcessRead {
  return PageProcessReadToJSONTyped(json, false);
}

export function PageProcessReadToJSONTyped(
  value?: PageProcessRead | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    total: value["total"],
    items: (value["items"] as Array<any>).map(ProcessReadToJSON),
    limit: value["limit"],
    offset: value["offset"],
  };
}
